import { Component, Input, OnInit } from '@angular/core';

var cascadeArray = document.getElementsByClassName('gray-bar');
setInterval(function () {
  for (var i = 0; i < cascadeArray.length; i++) {
    cascadeArray[i].classList.toggle('animate');
  }
}, 1300);

@Component({
    selector: 'an-fav-empty-tile',
    templateUrl: './fav-empty-tile.component.html',
    styleUrls: ['./fav-empty-tile.component.scss'],
    standalone: false
})
export class FavEmptyTileComponent implements OnInit {

  

  ngOnInit(): void {

  }

}
